export default "__VITE_ASSET__DjmZ9dBy__"